<template>
  <div style="position: absolute; width: 100%; height: 100%; overflow: hidden">
    <LiveTitle />
    <iframe :src="src" style="height: 100%; width: 100%"></iframe>
  </div>
</template>

<script>
import { Dialog } from "vant";
import LiveTitle from "@/components/common/Live/liveTitle";
export default {
  components: {
    LiveTitle,
  },
  data() {
    return {
      src: "",
      deleHuan: "",
    };
  },
  created() {
    let query = this.$route.query;
    if (!this.isNotNull(query.lookDress)) {
      Dialog.alert({
        title: "提示",
        message: "获取直播信息失败,请重试",
      }).then(() => {
        window.history.back();
      });
    } else {
      this.src = query.lookDress;
    }
  },
};
</script>

<style scoped>
</style>